import { Tag } from '@servicetitan/design-system';
import { observer } from 'mobx-react';
import { FC, useMemo } from 'react';
import { EstimateContainerWebModel } from '../../../api/portal-dashboard.api';
import { EstimateStatus } from '../../../enums/estimate-status';
import {
    ProposalStatus,
    ProposalStatusColor,
    ProposalStatusTagSubtle,
    ProposalStatusText,
} from '../../../enums/proposal-status';

interface ProposalsListItemProps {
    proposal: EstimateContainerWebModel;
}

const getProposalStatus = (item: EstimateContainerWebModel): ProposalStatus => {
    if (item.estimates.every(e => (e.status as number) === (EstimateStatus.Expired as number))) {
        return ProposalStatus.Expired;
    }

    if (item.estimates.every(e => (e.status as number) === (EstimateStatus.Dismissed as number))) {
        return ProposalStatus.Dismissed;
    }

    return item.estimates.some(e => (e.status as number) === (EstimateStatus.Sold as number))
        ? ProposalStatus.Accepted
        : ProposalStatus.Open;
};

export const ProposalsListItemStatus: FC<ProposalsListItemProps> = observer(props => {
    const { proposal } = props;

    const status = useMemo(() => {
        return getProposalStatus(proposal);
    }, [proposal]);

    return (
        <Tag subtle={ProposalStatusTagSubtle[status]} color={ProposalStatusColor[status]}>
            {ProposalStatusText[status]}
        </Tag>
    );
});
